import { CadcContractNotice } from '@/components/CadcContractNotice'
import { TransactionType, useBuySellStore } from '@/reducers/transactionReducer'
import { PaymentTypes, StableCoins } from '@/utils/currencies'

import { InteracBuyInstructions } from './BuyInstructions'
import { InteracRequestInstructions } from './InteracRequestInstructions'
import { SellTransactionInstructions } from './SellTransactionInstructions'

type TransactionInstructionsProps = {
  orderId: string
  wallet: string
  depositAddress: string | null
}

export const TransactionInstructions = ({
  orderId,
  wallet,
  depositAddress,
}: TransactionInstructionsProps) => {
  const transactionType = useBuySellStore.use.transactionType()
  const requestType = useBuySellStore.use.requestType()
  const stableCoin = useBuySellStore.use.stableCoin()
  const network = useBuySellStore.use.network()

  const cadcNotice = stableCoin === StableCoins.CADC && (
    <CadcContractNotice network={network} transactionType={transactionType} />
  )

  if (transactionType === TransactionType.SELL) {
    return (
      <div data-testid="container-transaction-sell-instructions">
        {cadcNotice}
        <SellTransactionInstructions
          sourceWallet={wallet}
          orderId={orderId}
          depositAddress={depositAddress}
        />
      </div>
    )
  }
  if (requestType === PaymentTypes.REQUEST) {
    return (
      <div data-testid="container-transaction-interac-request">
        {cadcNotice}
        <InteracRequestInstructions wallet={wallet} orderId={orderId} />
      </div>
    )
  }
  return (
    <div data-testid="container-transaction-interac-buy">
      {cadcNotice}
      <InteracBuyInstructions wallet={wallet} orderId={orderId} />
    </div>
  )
}
